module.exports = __webpack_public_path__ + "static/media/alarm-snooze.6c8ae8dc.svg";